export default __webpack_public_path__ + "static/media/Vector.83562ec1.png";